import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import Container from '@mui/material/Container';
import { checkToken, getToken, getPermission } from '../auth/ApiAuth';
import Navbar from '../components/Navbar'
import Footer from "../components/Footer";
import Box from '@mui/material/Box';
import UserListStats from '../components/UserListStats'
import DialogEditDriver from '../components/DialogEditDriver'
import ConfirmDialog from '../components/DialogConfirmDelete';
import AlertCard from '../components/AlertCard'

import { setCounterLoading, getTypeCounter } from '../redux/actions/lessons'
import { setDrivers, updateDriver, setEditedDriver, editDriver, createDriver, resetEditedDriver, deleteDriver } from '../redux/actions/driver'
import { getStudentIds, getStudentsByIds, getPaginatedStudents } from '../api/users'

import moment from 'moment'

const Students = ({
  editedDriver,
  editDriver
}) => {
  const dispatch = useDispatch()
  let history = useHistory();
  if (checkToken(getToken()) || getPermission('student')) {
    history.push("/Login");
  }

  const [driverDialogOpen, setDriverDialogOpen]   = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [deletedDriverId, setDeletedDriverId]     = useState('');
  const [isAlertCardOpen, setIsAlertCardOpen]     = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [prevRowsPerPage, setPrevRowsPerPage] = useState(20);
  const [allIds, setAllIds] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [searchActive, setSearchActive] = useState(false);
  

  const studentCounters = useSelector(state => state.lesson.typeCounter.counter)

  const AlertCardConst = (
    <AlertCard
      type="error"
      value="Nie udało się zaktualizować danych kursanta. Spróbuj ponownie."
    />
  )

  useEffect(() => {
    const startDate = moment("2015-01-01T00:00:00").format('YYYY-MM-DD HH:mm');
    const endDate   = moment().format('YYYY-MM-DD HH:mm');

    dispatch(setCounterLoading(false));
    dispatch(getTypeCounter('student', startDate, endDate));

    (async () => {
      try {
        const idsResp = await getStudentIds({ is_active: true });
        const ids = Array.isArray(idsResp?.ids) ? idsResp.ids : [];
        setAllIds(ids);
        setRowCount(ids.length);
        await fetchPage(0, rowsPerPage, ids);
      } catch (e) {
        console.log(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  async function fetchPage(newPage, newRowsPerPage, ids = allIds) {
    const start = newPage * newRowsPerPage;
    const end = start + newRowsPerPage;
    const slice = ids.slice(start, end);
    const resp = await getStudentsByIds(slice);
    const list = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : []);
    dispatch(setDrivers(list));
  }

  const handleServerPageChange = async (newPage) => {
    setPage(newPage);
    await fetchPage(newPage, rowsPerPage);
  };

  const handleServerRowsPerPageChange = async (value) => {
    if (searchActive) { // ignore rows-per-page changes during search, but keep state
      setPrevRowsPerPage(value === -1 ? 20 : value)
      return
    }
    setRowsPerPage(value);
    setPage(0);
    await fetchPage(0, value);
  };

  const reloadIdsAndPage = async (desiredPage = page, desiredRowsPerPage = rowsPerPage) => {
    try {
      const idsResp = await getStudentIds({ is_active: true });
      const ids = Array.isArray(idsResp?.ids) ? idsResp.ids : [];
      setAllIds(ids);
      const newCount = ids.length;
      setRowCount(newCount);
      const maxPage = desiredRowsPerPage > 0 ? Math.max(0, Math.ceil(newCount / desiredRowsPerPage) - 1) : 0;
      const safePage = Math.min(desiredPage, maxPage);
      setPage(safePage);
      await fetchPage(safePage, desiredRowsPerPage, ids);
    } catch (e) {
      console.log(e);
    }
  };

  // API-based search like DialogEvent with debounce
  const searchTimer = useRef(null);
  const handleServerSearchChange = (value) => {
    const q = (value || '').trim();
    if (searchTimer.current) clearTimeout(searchTimer.current);
    if (q.length === 0) {
      setSearchActive(false);
      if (rowsPerPage === -1) setRowsPerPage(prevRowsPerPage || 20);
      // immediate reset without extra delay
      reloadIdsAndPage(0, prevRowsPerPage || rowsPerPage);
      return;
    }
    searchTimer.current = setTimeout(async () => {
      setSearchActive(true);
      if (rowsPerPage !== -1) { setPrevRowsPerPage(rowsPerPage); setRowsPerPage(-1); }
      try {
        const params = q.includes(' ')
          ? { name: q, is_active: true }
          : { search: q, is_active: true };
        const resp = await getPaginatedStudents(params);
        const list = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : []);
        dispatch(setDrivers(list));
        setRowCount(list.length);
        setPage(0);
      } catch (e) { console.log(e); }
    }, 400);
  };

  const handleSubmitDriver = async (RegData, driverData) => {
    if (RegData.password) {
      if (RegData.password.length >= 8) {
        if (editedDriver.isEdited()) {
          await dispatch(updateDriver(RegData, editedDriver.pk));
        } else {
          await dispatch(createDriver(RegData, driverData));
        }
      } else {
        setIsAlertCardOpen(true);
        window.setTimeout(setIsAlertCardOpen, 2000, false);
      }
    }
    else {
      if (editedDriver.isEdited()) {
        await dispatch(updateDriver(RegData, editedDriver.pk));
      } else {
        await dispatch(createDriver(RegData, driverData));
      }
    }

    setDriverDialogOpen(false);
    await reloadIdsAndPage(0, rowsPerPage);
  };

  const handleAddDriverClick = () => {
    setDriverDialogOpen(true);
  };
  const handleDriverEditdDialogClose = () => {
    dispatch(resetEditedDriver())
    setDriverDialogOpen(false);
  };
  const handleEditDriverClick = (driver) => {
    dispatch(setEditedDriver(driver))
    setDriverDialogOpen(true);
  };
  const handleDeleteDriverClick = (driver) => {
    setDeletedDriverId(driver.pk)
    setConfirmDialogOpen(true)
  }
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false)
  }
  const handleConfirmDeleteDriver = async () => {
    await dispatch(deleteDriver(deletedDriverId))
    setConfirmDialogOpen(false)
    setDeletedDriverId('');
    await reloadIdsAndPage(page, rowsPerPage);
  }
  const confirmContentText = `Usunięcie konta kursanta jest operacją nieodwracalną.
  Czy na pewno chcesz usunąć konto tego użytkownika?`;

  //const driverAction = dispatch(editDriver())
  //const editedDriver = useSelector(state => state.driver.editedDriver)

  const drivers = useSelector(state => state.driver)
  return (
    <Box>
      <Container component="main" maxWidth="lg">
        <Navbar />
        {isAlertCardOpen ? AlertCardConst : ''}
       
        <DialogEditDriver
          editedDriver={editedDriver}
          open={driverDialogOpen}
          onChange={editDriver}
          onClose={handleDriverEditdDialogClose}
          onSubmit={handleSubmitDriver}
        />
        <ConfirmDialog
          open={confirmDialogOpen}
          onConfirm={handleConfirmDeleteDriver}
          onClose={handleConfirmDialogClose}
          title="Usuwanie konta kursanta"
          contentText={confirmContentText}
        />
        <UserListStats
          users={drivers.driversList}
          counters={studentCounters}
          serverPagination
          page={page}
          rowsPerPage={rowsPerPage}
          rowCount={rowCount}
          onServerPageChange={handleServerPageChange}
          onServerRowsPerPageChange={handleServerRowsPerPageChange}
          onServerSearchChange={handleServerSearchChange}
          isAddable={true}
          onAddUser={handleAddDriverClick}
          onEditUser={handleEditDriverClick}
          onDeleteUser={handleDeleteDriverClick}
          isArchive={false}
          isActiveField
          addableUsers
          editableUsers
          overallLessonsField
        />
      </Container>
      <Footer/>
    </Box>
  );
}
const mapStateToProps = (state) => ({
  editedDriver: state.driver.editedDriver
})

const mapDispatchToProps = (dispatch) => ({
  editDriver: (editDriverData) => dispatch(editDriver(editDriverData))
});


export default connect(mapStateToProps, mapDispatchToProps)(Students);
